export const INDEX_PATH = '/'
export const CART_PATH = '/cart'
export const CONTACT_US_PATH = '/contact-us'
export const PRODUCTS_PATH = '/products'
export const BLOG_PATH = '/blog'
export const BLOG_POSTS_PATH = '/blog/posts'
export const FAQ_PATH = '/faq'
